import React from 'react';
import { TouchableOpacity, Linking } from 'react-native';
import Text, { H3 } from '@dbk/ui-text';
import {PALETTE} from '../../../constants'

import '../../../../../../src/screens/modal-content/sign-up-modal/style.css';

const openExternalLink = (url) => {
    Linking.canOpenURL(url).then(supported => {
      if (supported) {
        Linking.openURL(url);
      }
    });
  }

export default (props) => {
  const { i18n: { messages } } = props;

  return (
    <div className="sign-up-modal">
      {/* <div className="margin-bottom-10">
        <H3 className="sign-up-title">{messages['app.auth.signUp.title']}</H3>
      </div>
      <div className="sign-up-separator" /> */}
      <div className="sign-up-content">
        <div>
          <Text className="sign-up-content-color">{messages['app.auth.signUp.textCurrentUserCH']}</Text>
        </div>
        <div>
          <br />
          <Text className="sign-up-content-color">{messages['app.auth.signUp.textNewUserCH']}</Text>
          <TouchableOpacity onPress={() => openExternalLink('https://deutschewealth.com')} >
                <Text className="text-link" style={{color: PALETTE.primaryActive}}>{messages['app.auth.signUp.textNewUserCHLink']}</Text>
          </TouchableOpacity>
        </div>
      </div>
    </div>
  );
};
